
import './assets/css/common.scss'
import KZ from './assets/js/utils.js'

window.KZ = KZ;
const conf = process.env;

window.KZ_CONFIG = conf;



// WEBPACK FOOTER //
// ./src/config.js